module.exports = __webpack_public_path__ + "static/media/logos3.c7561fc4.png";